import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Webdevs, you have no idea how much you know",
  "description": "",
  "published": "2012-03-12T00:00:00.000Z",
  "redirect_from": ["/blog/webdevs-you-have-no-idea-how-much-you-know/swizec/3891"],
  "categories": "Cascading Style Sheets, Education, Git, HTML, HTML element, JavaScript, jQuery, Notepad++, Text editor, Uncategorized, Web design",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A few weeks ago I decided I need a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Web_design",
        "title": "Web design"
      }}>{`web designer`}</a>{` in my close friends circle - someone to slap together designs for my half-baked weekend project ideas.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/Book_of_Knowledge2.jpg",
        "alt": "English: Book of Knowledge",
        "title": "English: Book of Knowledge"
      }}></img></p>
    <p>{`So I took the `}<a parentName="p" {...{
        "href": "http://twitter.com/ponywithhiccups"
      }}>{`nearest person with an eye for design`}</a>{` and convinced her she'd be perfect for redesigning my blog. Completely out of her depth (is usually an architecture student), but after two days she learned enough `}<a parentName="p" {...{
        "href": "http://www.adobe.com/products/indesign/main.html",
        "title": "Adobe InDesign"
      }}>{`inDesign`}</a>{` to produce something we were both happy with.`}</p>
    <p>{`Even made it all interactive and stuff!`}</p>
    <p>{`But as every good designer `}<em parentName="p">{`guy who turns a pdf into html+`}<a parentName="em" {...{
          "href": "http://en.wikipedia.org/wiki/Cascading_Style_Sheets",
          "title": "Cascading Style Sheets"
        }}>{`css`}</a>{`+js`}</em>{` knows, the tough part isn't drawing pretty pictures and making the information architecture work - the hard part is making browsers understand this stuff, possibly in a cross-platform way, with a touch of responsiveness thrown in the mix.`}</p>
    <p>{`My days of being `}<em parentName="p">{`that guy`}</em>{` ended towards the final throes of the War Against `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Tableless_web_design",
        "title": "Tableless web design"
      }}>{`Tables for Layout`}</a>{`. Back when `}<em parentName="p">{`:after {content: ":"}`}</em>{` and `}<em parentName="p">{`:first-child`}</em>{` were the state of the art and `}<a parentName="p" {...{
        "href": "http://jquery.com/",
        "title": "JQuery"
      }}>{`jQuery`}</a>{` was gaining widespread popularity.`}</p>
    <p>{`I can implement a half-baked `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Front_and_back_ends",
        "title": "Front and back ends"
      }}>{`frontend`}</a>{`, but turning designers' work into code is something I vowed never to do again! Soul crushingly maddening stuff that.`}</p>
    <p>{`Time to teach my fledgling webdesigner all about html and css.`}</p>
    <h2 {...{
      "id": "the-web-from-scratch"
    }}>{`The Web, from scratch`}</h2>
    <p>{`Until I started teaching `}<a parentName="p" {...{
        "href": "http://twitter.com/ponywithhiccups"
      }}>{`@ponywithhiccups`}</a>{` I had no idea web development was `}<em parentName="p">{`this`}</em>{` complex. It's insane!`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/Notepad_plus_plus2.png",
        "alt": "English: Icon for Notepad++",
        "title": "English: Icon for Notepad++"
      }}></img></p>
    <p><em parentName="p">{`"Ok, so you use html for layout and then css styles it"`}</em></p>
    <p>{`"Uhm ..."`}</p>
    <p><em parentName="p">{`"Right, well, html is an xml-like markup language; the website is organized into tags that semantically tell the browser how things fit together"`}</em></p>
    <p>{`"What's `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/HTML_element",
        "title": "HTML element"
      }}>{`a tag`}</a>{`?"`}</p>
    <p><em parentName="p">{`"Oh ... hmm ... it's just this `}{`<`}{`something>content`}{`<`}{`/something> thing."`}</em></p>
    <p>{`"And what does it do?"`}</p>
    <p><em parentName="p">{`"Well, it tells the browser whether something is a paragraph or a header ... and how things fit together ... and under certain conditions it also tells the browser what something looks like ... unless you have a css reset, then it doesn't ... oh and block elements always break into a new line, whereas inline elements do not ..."`}</em></p>
    <p>{`"Bwuh ... what's a css reset?"`}</p>
    <p><em parentName="p">{`"Right ... well, css tells the browser how to render the page. Colours, fonts, even layout"`}</em></p>
    <p>{`"But you just said html is for layout"`}</p>
    <p><em parentName="p">{`"Yes, well, css can rearrange that layout completely; html is really more about semantic stuff these days, but it used to be mostly for layout"`}</em></p>
    <p>{`"Okay ... then what's an inline or a block element?"`}</p>
    <p><em parentName="p">{`"Oh you know, things like a and span are inline, but divs and headers are blocks. Blocks just mean it breaks into a new line if it needs to."`}</em></p>
    <p>{`"Maybe you should just show me ..."`}</p>
    <p><em parentName="p">{`"Okay, just fire up a `}<a parentName="em" {...{
          "href": "http://en.wikipedia.org/wiki/Text_editor",
          "title": "Text editor"
        }}>{`text editor`}</a>{` ... no not notepad ... no, not wordpad either. Right ... what's a good text editor for windows anyway ..."`}</em></p>
    <p>{`We settled on `}<a parentName="p" {...{
        "href": "http://www.notepad-plus-plus.org/",
        "title": "Notepad++"
      }}>{`notepad++`}</a>{`, I've used it before and it's got pretty good syntax highlighting for everything. Didn't want to plunge her into emacs or something :P`}</p>
    <p><em parentName="p">{`"Right, so now you just write some html in here ... oh and I should teach you about `}<a parentName="em" {...{
          "href": "http://en.wikipedia.org/wiki/Revision_control",
          "title": "Revision control"
        }}>{`source control`}</a>{`"`}</em></p>
    <p>{`"What's source control?"`}</p>
    <p><em parentName="p">{`"Oh, that's just so you never lose your history, so you can jump back if something gets really messed up."`}</em></p>
    <p>{`"Awesome! Wow, developers really think of everything, I wish I used some sort of source control elsewhere"`}</p>
    <p>{`(I might be embelishing, but that's the gist)`}</p>
    <h2 {...{
      "id": "to-the-github"
    }}>{`To the github`}</h2>
    <p><a parentName="p" {...{
        "href": "http://git-scm.com",
        "title": "Git (software)"
      }}>{`Git`}</a>{` is this super simple thing right? Everyone who does any serious work with code can think in branches and pushing and pulling and commiting and merging ... it's second nature. Muscle memory almost.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/4325726291_7535aa8037-300x199.jpg",
        "alt": "An octocat",
        "title": "An octocat"
      }}></img></p>
    <p>{`Turns out this is a pretty damn complicated part of the process.`}</p>
    <p>{`First you need a github account (you don't, but it's the easiest way to teach a newbie about offsite backups without telling them that's what they are) ... I mean, just teach these freshlings best practices from the get go. No need to explain `}<em parentName="p">{`too many`}</em>{` details :)`}</p>
    <p>{`She got a github account and groked the basics of using git pretty quickly. After every few characters you press `}<em parentName="p">{`ctrl+s`}</em>{`, after a unit of work you `}<em parentName="p">{`rescan, stage changes, commit`}</em>{` (in a gui) and when something works you `}<em parentName="p">{`push`}</em>{`.`}</p>
    <p>{`Simple stuff.`}</p>
    <p>{`A few days later I sent her the first pull request - now she knows all about social coding. She understands the value of `}<a parentName="p" {...{
        "href": "http://github.com",
        "title": "GitHub"
      }}>{`Github`}</a>{` is that people can see what you're doing and pitch in to help when they want to. You have to `}<em parentName="p">{`pull`}</em>{` their code to your local repository, then you get to play with `}<em parentName="p">{`merge conflicts`}</em>{` and finally push it all back to Github.`}</p>
    <p>{`She can even use `}<em parentName="p">{`gh-pages`}</em>{`!`}</p>
    <p>{`Although in retrospect, maybe I should have told her she can check out the html locally and doesn't need to update gh-pages every time ...`}</p>
    <h2 {...{
      "id": "teaching-afresh"
    }}>{`Teaching afresh`}</h2>
    <p>{`The best thing about teaching someone all this stuff from scratch, is that she is a completely clean slate. No preconceptions of how code works, no idea that tables used to be for layout, no `}<em parentName="p">{`<`}{`font>`}</em>{` tag or anything else that is absolutely atrocious.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/300px-Teaching-8001.jpg",
        "alt": "Teaching in Thekchen Choling",
        "title": "Teaching in Thekchen Choling"
      }}></img></p>
    <p>{`Here is a designer that will never know the world before html5 and css3, that considers this stuff as normal, not as something new and somewhat scary.`}</p>
    <p>{`That's a good thing!`}</p>
    <p>{`Back when I was learning webdev the best advice for using table-less design was `}<em parentName="p">{`display: table-cell;`}</em>{` Yup, it was!`}</p>
    <p>{`Furthermore, I had no-one to teach me cleanly. To tell me about how the web works, that it's a stateless protocol, that you have a frontend and a backend.`}</p>
    <p>{`Perhaps back then it wasn't even so cleanly separated, MVC backends were still an exciting new technology and `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Ajax_%28programming%29",
        "title": "Ajax (programming)"
      }}>{`AJAX`}</a>{` only came into existence when I was already in the game for a few years.`}</p>
    <h2 {...{
      "id": "barely-scratching-the-surface"
    }}>{`Barely scratching the surface`}</h2>
    <p>{`You might think html and css are that simple thing anyone can do ... that they're just something everyone is born with at least a functioning knowledge of.`}</p>
    <p>{`But here's the truth, `}<em parentName="p">{`that shit is `}<strong parentName="em">{`hard`}</strong>{`.`}</em>{` And that's not even getting into nginx servers, caching, http protocols, MVC backends, MVC frontends, databases, event-based stuff, multithreading and so on and on ad nauseum.`}</p>
    <p>{`The average web developer's brain contains so much knowledge it's absolutely mindboggling! ... and a lot of companies want to pay them peanuts, because hey, that neighbour kid "does websites" and he'd do it for free.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://stevenscottstudio.wordpress.com/2012/03/08/demystifying-css/"
        }}>{`Demystifying CSS`}</a>{` (stevenscottstudio.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.mozilla.com/webdev/2012/03/09/better-know-a-webdev-luke-crouch-aka-groovecoder/"
        }}>{`Mozilla Web Development: Better Know a WebDev: Luke Crouch (aka groovecoder)`}</a>{` (mozilla.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://bjconquest.com/2012/03/06/16-useful-boilerplates-to-start-your-project-quickly/"
        }}>{`16 Useful Boilerplates to Start Your Project Quickly`}</a>{` (bjconquest.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.nofluffjuststuff.com/blog/terry_ryan/2012/01/css_tables_and_responsive_design"
        }}>{`CSS Tables and Responsive Design`}</a>{` (nofluffjuststuff.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.iprofs.nl/2012/03/05/webapplications-with-node-js-jade/"
        }}>{`Webapplications with node.js - Jade`}</a>{` (iprofs.nl)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://zapier.com/blog/2012/02/23/backbonejs-within-chrome-extension/"
        }}>{`Backbone.js and Chrome Extensions`}</a>{` (zapier.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://discoveringmuse.wordpress.com/2012/03/09/musings-of-a-has-been-web-designer/"
        }}>{`Musings of a has-been web designer`}</a>{` (discoveringmuse.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.cutoutandkeep.net//projects/github-octocat"
        }}>{`Projects " How-To's " Git Hub Octocat`}</a>{` (cutoutandkeep.net)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=d1ac8b4a-0336-49c7-aca6-e7b68618ae29",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      